import { render } from "./Footer.vue?vue&type=template&id=32ac3508&scoped=true"
const script = {}

import "./Footer.vue?vue&type=style&index=0&id=32ac3508&lang=scss&scoped=true"

import exportComponent from "/Users/richardpitul/Projects/booking-calendars/titans-booking-calendar/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32ac3508"]])

export default __exports__